import React from 'react';
import Icon, { type IconType } from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import type {
  ReturnType as LabelWithStatusType,
  LabelStatus,
} from '~/components/page/LFA/utils/getCardDateLabelByStatus';
import type { ThemeColor } from '~/theme/System/tokens/colorPalette';

type Props = {
  dataTestId?: string;
  className?: string;
  labelWithStatus: LabelWithStatusType;
  variant?: 'primary' | 'secondary';
};

const getColor = (labelStatus: LabelStatus): ThemeColor => {
  switch (labelStatus) {
    case 'done': {
      return { group: 'success' };
    }
    case 'snoozed':
    case 'rescheduled':
    case 'appointment':
    default: {
      return { group: 'primary', variant: 'light' };
    }
  }
};

const AppointmentDateLabel: React.FCC<Props> = ({
  dataTestId,
  className,
  labelWithStatus,
}) => {
  if (!labelWithStatus) {
    return null;
  }
  const { labelStatus, label } = labelWithStatus;

  const color: ThemeColor = getColor(labelStatus);
  const icon: IconType = labelStatus === 'snoozed' ? 'clock' : 'calendar';

  return (
    <JustificationContainer
      dataTestId={dataTestId}
      className={className}
      align="center"
      gap={'xxs'}
      width="100%"
    >
      {labelStatus === 'done' ? (
        <Icon
          style={{ margin: 0 }}
          name="check"
          background={{ group: 'success', variant: 'translucent' }}
          color={color}
        />
      ) : (
        <Icon
          name={icon}
          margin={[null, null, labelStatus === 'snoozed' ? null : 'xxxs', null]}
          color={color}
        />
      )}

      <Body margin={[null]} size="s" fontWeight="semiBold" color={color}>
        {label}
      </Body>
    </JustificationContainer>
  );
};

export default AppointmentDateLabel;
